import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
//siehe app.config.ts für Moduleloader
import { appConfig } from './app/app.config';




registerLocaleData(localeDe);
bootstrapApplication(AppComponent,appConfig ).catch((err) => console.error(err));

